import { render, staticRenderFns } from "./personsetup.vue?vue&type=template&id=eafb0ce6&scoped=true&"
import script from "./personsetup.vue?vue&type=script&lang=js&"
export * from "./personsetup.vue?vue&type=script&lang=js&"
import style0 from "./personsetup.vue?vue&type=style&index=0&id=eafb0ce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eafb0ce6",
  null
  
)

export default component.exports